"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconRss = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M14.87 50.56a4.57 4.57 0 1 0 4.57 4.57 4.57 4.57 0 0 0-4.57-4.57zm0 12.43a7.87 7.87 0 1 1 7.87-7.87A7.88 7.88 0 0 1 14.87 63z"
  }), _react["default"].createElement("path", {
    d: "M11.13 28.41a.83.83 0 0 0-.52.19.81.81 0 0 0-.3.64v4.07a.82.82 0 0 0 .65.8A32.84 32.84 0 0 1 27 43a32.83 32.83 0 0 1 8.88 16 .82.82 0 0 0 .8.65h4.07a.83.83 0 0 0 .81-1A38.37 38.37 0 0 0 31.07 39 38.37 38.37 0 0 0 11.3 28.43h-.17zM40.76 63h-4.07a4.1 4.1 0 0 1-4-3.23 29.53 29.53 0 0 0-8-14.46 29.54 29.54 0 0 0-14.46-8 4.1 4.1 0 0 1-3.23-4v-4.07a4.13 4.13 0 0 1 4.94-4 41.65 41.65 0 0 1 21.47 11.47 41.66 41.66 0 0 1 11.4 21.35 4.13 4.13 0 0 1-4 4.93z"
  }), _react["default"].createElement("path", {
    d: "M11.12 10.3a.81.81 0 0 0-.53.2.82.82 0 0 0-.28.62v4A.82.82 0 0 0 11 16a50.36 50.36 0 0 1 28.35 14A50.85 50.85 0 0 1 49 43.12 50.37 50.37 0 0 1 54 59a.83.83 0 0 0 .82.72h4a.82.82 0 0 0 .62-.28.81.81 0 0 0 .2-.64 55.94 55.94 0 0 0-5.36-17.58 56.44 56.44 0 0 0-10.4-14.64A56.48 56.48 0 0 0 29.1 15.82a56 56 0 0 0-17.87-5.51zM58.87 63h-4a4.16 4.16 0 0 1-4.09-3.56A47.08 47.08 0 0 0 46 44.63a47.55 47.55 0 0 0-9-12.25 47.09 47.09 0 0 0-26.44-13.14A4.15 4.15 0 0 1 7 15.16v-4A4.12 4.12 0 0 1 11.67 7a59.26 59.26 0 0 1 18.92 5.83 59.76 59.76 0 0 1 15.64 11.43 59.74 59.74 0 0 1 11.05 15.46A59.23 59.23 0 0 1 63 58.34 4.12 4.12 0 0 1 58.87 63z"
  })),
  height: undefined,
  width: undefined
});
IconRss.displayName = 'IconRss';
var _default = IconRss;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/rss.js
// module id = 616
// module chunks = 0